import { EmployeeStatusBadge } from '@/common/components/shared/badge/EmployeeStatusBadge';
import { EmployeeLink } from '@/common/components/shared/link/EmployeeLink';
import { EMPTY_DEFAULT } from '@/common/components/shared/table/constants';
import { EmployeeStatus, type GetManagerQuery } from '@/common/graphql';
import { JobHistoryLevelLabels } from '@/common/types';

interface Props {
  managerInfo: NonNullable<GetManagerQuery['employee']>;
  showLink: boolean;
}

export const ManagerInfo = ({ managerInfo, showLink }: Props) => (
  <div className="mt-1 rounded border bg-gray-50 p-2 text-xs text-gray-600 leading-11">
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-1">
        <strong>Status:</strong>
        <EmployeeStatusBadge status={managerInfo.status} statusColorOverrides={{ [EmployeeStatus.Inactive]: 'red' }} />
      </div>
      {showLink && <EmployeeLink employeeId={managerInfo.id}>Detail</EmployeeLink>}
    </div>
    <div className="flex items-center gap-1">
      <strong>Company:</strong>
      <div>{managerInfo.currentMainContract?.company?.name || EMPTY_DEFAULT}</div>
    </div>
    <div className="flex items-center gap-1">
      <strong>Business Unit:</strong>
      <div>{managerInfo.currentPosition?.businessUnit?.name || EMPTY_DEFAULT}</div>
    </div>
    <div className="flex items-center gap-1">
      <strong>Name in Local Language:</strong>
      <div>{managerInfo.generalInformation?.nameInLocalLanguage || EMPTY_DEFAULT}</div>
    </div>
    <div className="flex items-center gap-1">
      <strong>Level:</strong>
      <div>
        {(managerInfo.currentPosition?.level && JobHistoryLevelLabels[managerInfo.currentPosition.level]) ||
          EMPTY_DEFAULT}
      </div>
    </div>
  </div>
);
